<h2 mat-dialog-title>Dodawanie notatki do wydatku</h2>
<form (ngSubmit)="save()">
  <mat-dialog-content>
    <p class="mt-0">Notatka ułatwia zapamiętanie dodatkowych informacji dotyczących wydatku.</p>
    <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="16px">
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="Tekst notatki (opcjonalny)"
          [maxLength]="descriptionMaxLength"
          [appInputMaxLength]="descriptionMaxLength"
          [formControl]="description"
        />
        <mat-error *ngIf="description.errors?.maxLength || description.value?.length > descriptionMaxLength">
          Opis jest za długi
        </mat-error>
        <mat-hint align="end">{{ description.value?.length || '0' }}/90</mat-hint>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="start">
    <button
      mat-raised-button
      type="submit"
      color="accent"
      cdkFocusInitial
      [disabled]="description.invalid || description.value?.length > descriptionMaxLength"
    >
      Zapisz
    </button>
    <button mat-button [matDialogClose]="false">Anuluj</button>
  </mat-dialog-actions>
</form>
